<template>

    <div class="relation659">
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                    <img src="https://cdn.edstatic.com/203012120000/a1bb546186d14e7a380f1b72adeb2d6d/2025/12/ff0e9ea1-f855-447a-a120-444936b770fa.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                    <img src="https://cdn.edstatic.com/203012120000/c4c6f144974a065940e2693b9b17bbd3/2025/12/078b5c2e-e3dd-44bc-a020-0886d6aecaf7.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                    <img src="https://cdn.edstatic.com/203012120000/549cd7a6a1cda20554f8c88834b503dc/2025/12/dfa9fbba-eff2-4b2f-866a-70248b372518.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                    <img src="https://cdn.edstatic.com/203012120000/85043fb4b14f6a98b50bcbb5859bdd75/2025/12/be3ef15a-b70e-4ea1-9d1b-b099a5a499b1.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                    <img src="https://cdn.edstatic.com/203012120000/0da257527ca934c7b5514328a9942f96/2025/12/0fcd098a-0799-4ecc-a152-3c06fd58a76f.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                    <img src="https://cdn.edstatic.com/203012120000/4526329469e118e41c2c60d1ada4778f/2025/12/7eddf9ab-d46d-4051-bbdc-5b3865b88604.png"
                        alt="">
                </a>
            </van-col>
           
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img src="https://cdn.edstatic.com/203012120000/ae639a64610a931caf1422dc8af756ae/2025/12/1a12720a-ee1f-465d-988b-4e049a8c0368.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                    <img src="https:///cdn.edstatic.com/203012120000/87667210658543178923c01116bf56a8/2025/12/e9416e1a-0866-49c3-b7b8-a5952d263352.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
                    <img src="https://cdn.edstatic.com/203012120000/8f44aa4cbfdbbac8e28b0e9c0e690d70/2025/12/c073fa63-3afb-407f-95ae-1e56c47affa1.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[9])">
                    <img src="https://cdn.edstatic.com/203012120000/1ecb2f7b6df0df81664190e101037f70/2025/12/b9d6d660-5e38-41d6-bc74-ed78630c5991.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation659 {
    // overflow: auto;
    padding: 0.3rem 0.3rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.15rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation581 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button659.vue